// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","250":"d8b51237","369":"1aebde82","386":"accee6dd","458":"bbae8a6a","577":"66801e42","652":"34876035","682":"d5252985","783":"c66ca607","787":"7783b8ed","812":"e16e9c63","867":"b841bf4a","904":"0c67cfd9","985":"de897744"}[chunkId] + ".js";
};